import React, { useContext, useEffect, useState } from "react";
import { Modal, Button, TextInput, Label } from "flowbite-react";
import Button_submit from "../components/Button_submit";
import axios from "axios";
import GlobalContext from "../connections/GlobalContext";
import Swal from "sweetalert2";
import Head_data from "../components/Head_data";
import DataTable from "react-data-table-component";
import { Breadcrumb } from "flowbite-react";
import { HiHome } from "react-icons/hi";
import Select from "react-select";
import engineGif from "../image/engine.gif";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const Customer = ({ isSidebarOpen, theme }) => {
  const [open, setOpen] = useState(false);
  const { globalValue } = useContext(GlobalContext);
  const [customerName, setCustomerName] = useState("");
  const [mobile, setMobile] = useState("");
  const [vehicleNo, setVehicleNo] = useState("");
  const [engineNo, setEngineNo] = useState("");
  const [chasisNo, setChasisNo] = useState("");
  const [brand, setBrand] = useState("");
  const [model, setModel] = useState("");
  const [year, setYear] = useState("");
  const [address, setAddress] = useState("");
  const [flag_branch, setFlag_branch] = useState(
    sessionStorage.getItem("branch")
  );
  const [loading, setLoading] = useState(false);

  const [customerNameError, setCustomerNameError] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [vehicleNoError, setVehicleNoError] = useState("");
  const [engineNoError, setEngineNoError] = useState("");
  const [chasisNoError, setChasisNoError] = useState("");
  const [brandError, setBrandError] = useState("");
  const [modelError, setModelError] = useState("");
  const [yearError, setYearError] = useState("");
  const [addressError, setAddressError] = useState("");

  const [customers, setCustomers] = useState([]);
  const [mode, setMode] = useState("");
  const [username, setUsername] = useState("");
  const [flag_berror, setFlag_berror] = useState("");
  const [company_name, setCompany_name] = useState("");
  const [insurance_no, setInsurance_no] = useState("");
  const [company_error, setCompany_error] = useState("");
  const [insurance_error, setInsurance_error] = useState("");

  const [s_date, setS_date] = useState("");
  const [s_date_error, setS_date_error] = useState("");
  const [e_date, setE_date] = useState("");
  const [e_date_error, setE_date_error] = useState("");
  const [rcbook, setRcbook] = useState("");

  const [rc_start, setRc_start] = useState("");
  const [rc_start_error, setRc_start_error] = useState("");
  const [rc_end, setRc_end] = useState("");
  const [rc_end_error, setRc_end_error] = useState("");

  const [license, setLicense] = useState("");
  const [license_start, setLicense_start] = useState("");
  const [license_start_error, setLicense_start_error] = useState("");
  const [license_end, setLicense_end] = useState("");
  const [license_end_error, setLicense_end_error] = useState("");

  const [rcbookError, setRcbookError] = useState("");
  const [licenseError, setLicenseError] = useState("");
  const [isinsurance, setIsInsurance] = useState(false);

  const [value, setValue] = useState("");
  const [insurance_branch, setInsurance_branch] = useState();
  const [b_mobile_no, setB_mobile_no] = useState("");
  const [b_address_no, setB_address_no] = useState("");
  const [filteredOptions, setFilteredOptions] = useState([]);

  const [email_id, setEmail_id] = useState("");
  const [email_id_error, setEmail_id_error] = useState("");

  const [city, setCity] = useState("");
  const [city_error, setCity_error] = useState("");

  const [agent, setAgent] = useState("");
  const [agent_error, setAgent_error] = useState("");

  const [branch_code, setBranch_code] = useState("");
  const [branch_code_error, setBranch_code_error] = useState("");

  const [searchTerm, setSearchTerm] = useState("");
  const [filtered, setFiltered] = useState(customers);

  useEffect(() => {
    const filteredData = customers.filter(
      (customer) =>
        (customer[2] || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
        (customer[3] || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
        (customer[4] || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
        (customer[29] || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
        (customer[30] || "").toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFiltered(filteredData);
  }, [searchTerm, customers]);

  const handleRcbookChange = (e) => {
    // let value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "");

    // if (value.length > 12) return;

    // let formattedValue = value
    //     .replace(/^([A-Z]{2})(\d{0,2})([A-Z]{0,2})(\d{0,4})$/, (_, p1, p2, p3, p4) =>
    //         [p1, p2, p3, p4].filter(Boolean).join("-")
    //     );
    if (e.target.value !== "") {
      setRcbookError("");
    }
    setRcbook(e.target.value);

    // const rcbookPattern = /^[A-Z]{2}-\d{2}-[A-Z]{1,2}-\d{4}$/;
    // setRcbookError(formattedValue.match(rcbookPattern) ? "" : "Invalid RC Book Number (Format: KA-01-AB-1234)");
  };

  const handleLicenseChange = (e) => {
    // let value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "");

    // if (value.length > 14) return;

    // let formattedValue = value.replace(/^([A-Z]{2})(\d{0,12})$/, (_, p1, p2) =>
    //   [p1, p2].filter(Boolean).join("-")
    // );
    if (e.target.value !== "") {
      setLicenseError("");
    }
    setLicense(e.target.value);

    // const licensePattern = /^[A-Z]{2}-\d{6,12}$/;
    // setLicenseError(
    //   formattedValue.match(licensePattern)
    //     ? ""
    //     : "Invalid License Number (Format: TN-123456789012)"
    // );
  };

  const [insurance_type, setInsurance_type] = useState("");
  const [insurance_type_error, setInsurance_type_error] = useState("");
  const [branch_list, setBranche_list] = useState([]);
  const [gst_type, setGst_type] = useState("");
  const [gst_type_options, setGst_type_options] = useState([]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "customerName") {
      const validName = value.replace(/[^a-zA-Z\s]/g, "");
      setCustomerName(validName);
    }

    if (name === "mobile") setMobile(value);
    if (name === "vehicleNo") setVehicleNo(value);
    if (name === "engineNo") setEngineNo(value);
    if (name === "chasisNo") setChasisNo(value);
    if (name === "brand") setBrand(value);
    if (name === "model") setModel(value);
    if (name === "year") setYear(value);
    if (name === "address") setAddress(value);
    if (name === "branch") setFlag_branch(value);
    if (name === "email_id") setEmail_id(value);
    if (name === "branch_code") setBranch_code(value);
    if (name === "company") {
      setCompany_name(value);
      setFilteredOptions([]);
      setB_mobile_no("");
      setInsurance_branch("");
      setB_address_no("");
      setBranche_list([]);
      setGst_type_options([]);
      setGst_type("");
      for (let i = 0; i < insurance.length; i++) {
        console.log(insurance[i]);
        if (insurance[i][1] === value) {
          if (Array.isArray(insurance[i][3])) {
            setBranche_list((prevList) => [...insurance[i][3]]);
          }
          if (Array.isArray(insurance[i][4])) {
            const options = insurance[i][4].map(gst => ({
              value: gst.gstName,
              label: gst.gstName
            }));
            setGst_type_options(options);
          }
          break;
        }
      }
    }

    if (name === "insurance") {
      setInsurance_no(value);
    }
    if (name === "s_date") setS_date(value);
    if (name === "e_date") setE_date(value);
    if (name === "rc_start") setRc_start(value);
    if (name === "rc_end") setRc_end(value);
    if (name === "license_start") setLicense_start(value);
    if (name === "license_end") setLicense_end(value);
    if (name === "insurance_type") setInsurance_type(value);

    if (name === "city") setCity(value);
    if (name === "agent") setAgent(value);

    validate(name, value);
  };

  const validate = (fieldName, value) => {
    switch (fieldName) {
      case "customerName":
        if (!value) setCustomerNameError("Customer name is required.");
        else setCustomerNameError("");
        break;
      case "mobile":
        if (!/^\d{10}$/.test(value))
          setMobileError("Mobile number must be 10 digits.");
        else setMobileError("");
        break;
      case "vehicleNo":
        if (!value) setVehicleNoError("Vehicle number is required.");
        else setVehicleNoError("");
        break;
      case "engineNo":
        if (!value) setEngineNoError("Engine number is required.");
        else setEngineNoError("");
        break;
      case "chasisNo":
        if (!value) setChasisNoError("Chasis number is required.");
        else setChasisNoError("");
        break;
      case "brand":
        if (!value) setBrandError("Brand is required.");
        else setBrandError("");
        break;
      case "model":
        if (!value) setModelError("Model is required.");
        else setModelError("");
        break;
      case "year":
        if (!value) setYearError("Year is required.");
        else setYearError("");
        break;
      case "address":
        if (!value) setAddressError("Address is required.");
        else setAddressError("");
        break;
      case "company":
        if (!value) setCompany_error("Insurance company name  is required.");
        else setCompany_error("");
        break;
      case "insurance":
        if (!value) setInsurance_error("Insurance number  is required.");
        else setInsurance_error("");
        break;
      case "insurance_type":
        if (!value) setInsurance_type_error("Insurance type  is required.");
        else setInsurance_type_error("");
        break;
      case "s_date":
        if (!value) setS_date_error("date  is required.");
        else setS_date_error("");
        break;
      case "city":
        if (!value) {
          setCity_error("City is required.");
        } else if (!/^[A-Za-z\s]+$/.test(value)) {
          setCity_error("City must contain only letters and spaces.");
        } else {
          setCity_error("");
        }
        break;

      case "agent":
        if (!value) setAgent_error("pincode is required.");
        else setAgent_error("");
        break;

      case "e_date":
        if (!value) setE_date_error("date  is required.");
        else setE_date_error("");
        break;
      case "email_id":
        // Email is optional, no validation required
        setEmail_id_error("");
        break;
      case "branch_code":
        // Branch code is optional, no validation required
        setBranch_code_error("");
        break;
      case "rc_start":
        if (!value) setRc_start_error("date  is required.");
        else setRc_start_error("");
        break;
      case "rc_end":
        if (!value) setRc_end_error("date  is required.");
        else setRc_end_error("");
        break;
      case "license_start":
        if (!value) setLicense_start_error("date  is required.");
        else setLicense_start_error("");
        break;
      case "license_end":
        if (!value) setLicense_end_error("date  is required.");
        else setLicense_end_error("");
        break;

      default:
        break;
    }
  };

  const handleSubmit = async () => {
    if (
      !customerName ||
      !mobile ||
      !vehicleNo ||
      !engineNo ||
      !chasisNo ||
      !brand ||
      !model ||
      !year ||
      !address ||
      vehicleNoError
    ) {
      if (!customerName) setCustomerNameError("Customer name is required.");
      if (!mobile) setMobileError("Mobile number is required.");
      if (!vehicleNo) setVehicleNoError("Vehicle number is required.");
      if (!engineNo) setEngineNoError("Engine number is required.");
      if (!chasisNo) setChasisNoError("Chasis number is required.");
      if (!brand) setBrandError("Brand is required.");
      if (!model) setModelError("Model is required.");
      if (!year) setYearError("Year is required.");
      if (!address) setAddressError("Address is required.");

      console.log("error in company name");
      return;
    }

    if (isinsurance) {
      if (
        !insurance_no ||
        !s_date ||
        !e_date ||
        !insurance_type ||
        !rcbook ||
        rcbookError ||
        !license ||
        licenseError ||
        !company_name ||
        rc_end_error ||
        !rc_start ||
        !rc_end ||
        rc_start_error ||
        license_start_error ||
        license_end_error ||
        !license_end ||
        !license_start
      ) {
        if (!insurance_no) setInsurance_error("Insurance number  is required.");
        if (!company_name)
          setCompany_error("Insurance company name is required.");
        if (!s_date) setS_date_error("Insurance start date is required.");
        if (!e_date) setE_date_error("Insurance end date is required.");
        if (!insurance_type)
          setInsurance_type_error("Insurance type is required.");
        if (!rcbook) setRcbookError("Rcbook is required.");
        if (!rc_start) setRc_start_error("Rcbook start date is required.");
        if (!rc_end) setRc_end_error("Rcbook end date is required.");

        if (!license_start)
          setLicense_start_error("License start date is required.");
        if (!license_end) setLicense_end_error("License end date is required.");

        if (!license) setLicenseError("License is required.");

        return;
      }
      // Insurance branch fields are optional, no check required
    }

    // const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    // if (!emailPattern.test(email_id)) {
    //     setEmail_id_error("Invalid email format");
    //     return;
    // } else {
    //     setEmail_id_error("");
    // }

    setLoading(true);
    try {
      const response = await axios.post(
        `${globalValue}/customer_submit`,
        {
          customerName,
          mobile,
          vehicleNo,
          engineNo,
          chasisNo,
          brand,
          model,
          year,
          address,
          flag_branch,
          insurance_no,
          company_name,
          insurance_branch,
          b_address_no,
          b_mobile_no,
          value,
          s_date,
          e_date,
          insurance_type,
          rcbook,
          license,
          isinsurance,
          email_id,
          branch_code,
          rc_start,
          rc_end,
          license_end,
          license_start,
          city,
          agent,
          gst_type,
        },
        {
          headers: {
            "x-access-token": sessionStorage.getItem("token"),
          },
        }
      );
      if (response.data === "success") {
        fetchData();
        setCustomerName("");
        setMobile("");
        setVehicleNo("");
        setEngineNo("");
        setChasisNo("");
        setBrand("");
        setModel("");
        setYear("");
        setAddress("");
        setCustomerNameError("");
        setMobileError("");
        setVehicleNoError("");
        setEngineNoError("");
        setChasisNoError("");
        setBrandError("");
        setModelError("");
        setYearError("");
        setAddressError("");
        setInsurance_no("");
        setInsurance_error("");
        setCompany_error("");
        setCompany_name("");
        setInsurance_type("");
        setRcbook("");
        setRcbookError("");
        setLicense("");
        setLicenseError("");
        setCity("");
        setCity_error("");
        setAgent("");
        setAgent_error("");
        setIsInsurance(false);
        setGst_type("");
        setGst_type_options([]);
        fetchData2();

        setBranch_code("");
        setBranch_code_error("");

        setS_date("");
        setS_date_error("");
        setE_date("");
        setE_date_error("");

        setRc_start("");
        setRc_start_error("");
        setRc_end("");
        setRc_end_error("");
        setLicense_end("");
        setLicense_start("");
        setLicense_end_error("");
        setLicense_start_error("");

        setEmail_id("");
        setEmail_id_error("");

        Swal.fire({
          icon: "success",
          title: "Customer Added Successfully",
        });
        setOpen(false);
      }
      if (response.data.success == 0) {
        Swal.fire({
          icon: "error",
          title: "Customer Vehicle no or Engine no Already Exist",
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = async () => {
    if (
      !customerName ||
      !mobile ||
      !vehicleNo ||
      !engineNo ||
      !chasisNo ||
      !brand ||
      !model ||
      !year ||
      !address
    ) {
      if (!customerName) setCustomerNameError("Customer name is required.");
      if (!mobile) setMobileError("Mobile number is required.");
      if (!vehicleNo) setVehicleNoError("Vehicle number is required.");
      if (!engineNo) setEngineNoError("Engine number is required.");
      if (!chasisNo) setChasisNoError("Chasis number is required.");
      if (!brand) setBrandError("Brand is required.");
      if (!model) setModelError("Model is required.");
      if (!year) setYearError("Year is required.");
      if (!address) setAddressError("Address is required.");
      return;
    }
    if (isinsurance) {
      if (
        !insurance_no ||
        !s_date ||
        !e_date ||
        !insurance_type ||
        !rcbook ||
        rcbookError ||
        !license ||
        licenseError ||
        !company_name ||
        rc_end_error ||
        !rc_start ||
        !rc_end ||
        rc_start_error ||
        license_start_error ||
        license_end_error ||
        !license_end ||
        !license_start
      ) {
        if (!insurance_no) setInsurance_error("Insurance number  is required.");
        if (!company_name)
          setCompany_error("Insurance company name is required.");
        if (!s_date) setS_date_error("Insurance start date is required.");
        if (!e_date) setE_date_error("Insurance end date is required.");
        if (!insurance_type)
          setInsurance_type_error("Insurance type is required.");
        if (!rcbook) setRcbookError("Rcbook is required.");

        if (!rc_start) setRc_start_error("Rcbook start date is required.");
        if (!rc_end) setRc_end_error("Rcbook end date is required.");

        if (!license_start)
          setLicense_start_error("License start date is required.");
        if (!license_end) setLicense_end_error("License end date is required.");

        if (!license) setLicenseError("License is required.");

        return;
      }
      // Insurance branch fields are optional, no check required
    }

    // const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    // if (!emailPattern.test(email_id)) {
    //     setEmail_id_error("Invalid email format");
    //     return;
    // } else {
    //     setEmail_id_error("");
    // }

    setLoading(true);
    try {
      const response = await axios.post(
        `${globalValue}/customer_edit`,
        {
          customerName,
          mobile,
          vehicleNo,
          engineNo,
          chasisNo,
          brand,
          model,
          year,
          address,
          username,
          flag_branch,
          company_name,
          insurance_branch,
          b_address_no,
          b_mobile_no,
          value,
          insurance_no,
          s_date,
          e_date,
          insurance_type,
          rcbook,
          license,
          isinsurance,
          email_id,
          branch_code,
          rc_start,
          rc_end,
          license_end,
          license_start,
          city,
          agent,
          gst_type,
        },
        {
          headers: {
            "x-access-token": sessionStorage.getItem("token"),
          },
        }
      );
      if (response.data === "success") {
        fetchData();
        setCustomerName("");
        setMobile("");
        setVehicleNo("");
        setEngineNo("");
        setChasisNo("");
        setBrand("");
        setModel("");
        setYear("");
        setAddress("");
        setInsurance_no("");
        setCompany_name("");
        setInsurance_type("");
        setRcbook("");
        setLicense("");
        setS_date("");
        setE_date("");
        setRcbook("");
        setLicense("");
        setBranch_code("");
        setCity("");
        setAgent("");

        setBranch_code_error("");
        setLicenseError("");
        setRcbookError("");
        setE_date_error("");
        setS_date_error("");
        setLicenseError("");
        setRcbookError("");
        setCompany_error("");
        setAddressError("");
        setInsurance_error("");
        setYearError("");
        setCustomerNameError("");
        setMobileError("");
        setVehicleNoError("");
        setEngineNoError("");
        setChasisNoError("");
        setBrandError("");
        setModelError("");
        setIsInsurance(false);
        setGst_type("");
        setGst_type_options([]);

        setRc_start("");

        setCity_error("");
        setAgent_error("");

        setRc_start_error("");
        setRc_end("");
        setRc_end_error("");
        setLicense_end("");
        setLicense_start("");
        setLicense_end_error("");
        setLicense_start_error("");

        fetchData2();

        Swal.fire({
          icon: "success",
          title: "Customer Edited Successfully",
        });
        setOpen(false);
      }
      if (response.data.success == 0) {
        Swal.fire({
          icon: "error",
          title: "Customer Vehicle no or Engine no Already Exist",
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const customStyles = {
    table: {
      style: {
        backgroundColor: theme === "dark" ? "rgb(31, 41, 55)" : "white",
        width: "100%",
        border:
          theme === "dark"
            ? "solid 1px rgb(63, 62, 62)"
            : "solid 1px rgb(226, 232, 240)",
      },
    },
    headCells: {
      style: {
        backgroundColor:
          theme === "dark" ? "rgb(55, 65, 81)" : "rgb(226, 232, 240)",
        color: theme === "dark" ? "white" : "black",
        fontWeight: "bold",
      },
    },
    cells: {
      style: {
        color: theme === "dark" ? "white" : "black",
        backgroundColor: theme === "dark" ? "rgb(31, 41, 55)" : "white",
        border:
          theme === "dark"
            ? "solid 1px rgb(63, 62, 62)"
            : "solid 1px rgb(255, 255, 255)",
      },
    },
    pagination: {
      style: {
        backgroundColor: theme === "dark" ? "rgb(31, 41, 55)" : "white",
        color: theme === "dark" ? "white" : "black", // Pagination text
        borderTop:
          theme === "dark" ? "solid 1px white" : "solid 1px rgb(226, 232, 240)", // Top border for pagination
      },
      pageButtonsStyle: {
        backgroundColor: theme === "dark" ? "rgb(31, 41, 55)" : "white", // Buttons background
        color: theme === "dark" ? "white" : "black", // Buttons text
        fill: theme === "dark" ? "white" : "black", // Arrow colors
        "&:hover": {
          backgroundColor:
            theme === "dark" ? "rgb(55, 65, 81)" : "rgb(226, 232, 240)", // Hover effect
        },
      },
    },
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${globalValue}/customers`, {
        params: {
          data: sessionStorage.getItem("branch"),
          position: "",
        },
        headers: {
          "x-access-token": sessionStorage.getItem("token"),
        },
      });
      setCustomers(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const [branches, setBranches] = useState([]);
  const fetchData1 = async () => {
    setLoading(true);
    try {
      const response = await fetch(globalValue + "/branches", {
        method: "GET",
        headers: { "x-access-token": sessionStorage.getItem("token") },
      });

      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response.status}`);

      const data = await response.json();
      setBranches(data);
    } catch (error) {
      console.error("Error fetching branches:", error);
    } finally {
      setLoading(false);
    }
  };

  const [insurance, setInsurance] = useState([]);
  const fetchData2 = async () => {
    setLoading(true);
    try {
      const response = await fetch(globalValue + "/insurance", {
        method: "GET",
        headers: { "x-access-token": sessionStorage.getItem("token") },
      });

      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response.status}`);

      const data = await response.json();
      setInsurance(data);
    } catch (error) {
      console.error("Error fetching insurance data:", error);
    } finally {
      setLoading(false);
    }
  };
  const [brands, setBrands] = useState([]);
  const fetchBrand = () => {
    fetch(globalValue + "/v_brand", {
      method: "GET",
      headers: {
        "x-access-token": sessionStorage.getItem("token"),
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setBrands(data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  const [modals, setModals] = useState([]);
  const fetchmodal = () => {
    fetch(globalValue + "/v_modal", {
      method: "GET",
      headers: {
        "x-access-token": sessionStorage.getItem("token"),
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setModals(data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  const filteredModels = modals
    .filter((item) => item[1] === brand)
    .map((item) => ({
      value: item[2],
      label: item[2],
    }));
  const [types, setTypes] = useState([]);
  const insurance_type_list = async () => {
    const response = await axios.get(`${globalValue}/insurance_type`, {});
    setTypes(response.data);
  };

  useEffect(() => {
    fetchData();
    fetchBrand();
    fetchmodal();
    fetchData1();
    fetchData2();
    insurance_type_list();
  }, []);

  const handleDelete = async (data) => {
    setLoading(true);
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this customer? This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });
    if (result.isConfirmed) {
      try {
        const response = await axios.post(
          `${globalValue}/customer_delete`,
          { data },
          {
            headers: {
              "x-access-token": sessionStorage.getItem("token"),
            },
          }
        );
        if (response.data === "success") {
          fetchData();
          Swal.fire({
            icon: "success",
            title: "Customer Deleted Successfully",
          });
        }
      } catch (error) {
        console.error("Error deleting customer:", error);
        Swal.fire(
          "Error!",
          "Something went wrong while deleting the customer.",
          "error"
        );
      } finally {
        setLoading(false);
      }
    }
  };

  const columns = [
    {
      name: "Customer Name",
      selector: (row) => row[2],
    },
    {
      name: "Mobile/whatsapp No",
      selector: (row) => row[3],
    },
    {
      name: "Vehicle No",
      selector: (row) => row[4],
    },
    {
      name: "Brand",
      selector: (row) => row[7],
    },
    {
      name: "Model",
      selector: (row) => row[8],
    },
    {
      name: "Year",
      selector: (row) => row[9],
    },
    {
      name: "Address",
      selector: (row) => row[10],
    },
    {
      name: "City",
      selector: (row) => row[29],
    },
    {
      name: "Pincode",
      selector: (row) => row[30],
    },
    {
      name: "Action",
      center: "true",
      cell: (row) => (
        <div className="flex gap-4">
          <button
            onClick={() => handleEditCustomer(row)}
            className="p-2 text-white border bg-blue-700 hover:bg-blue-800 rounded-md shadow-xl"
          >
            <i className="fa fa-edit"></i>
          </button>
          <button
            onClick={() => handleDelete(row[1])}
            className="p-2 text-white border bg-yellow-500 hover:bg-yellow-800 rounded-md shadow-xl"
          >
            <i className="fa fa-trash"></i>
          </button>
        </div>
      ),
    },
  ];

  const handleExportPDF = () => {
    const doc = new jsPDF();
    doc.setFontSize(6);
    doc.text("JALS AUTOMOBILES", 14, 10);
    let rows = [];
    let columns = [];
    columns = [
      "Customer Name",
      "Mobile No",
      "Vehicle No",
      "Brand",
      "Model",
      "Address",
      "City",
      "Pincode",
    ];
    console.log(filtered, "FLFLF");
    rows = filtered.map((row) => [
      row[2],
      row[3],
      row[4],
      row[7],
      row[8],
      row[10],
      row[29],
      row[30],
    ]);

    autoTable(doc, {
      head: [columns],
      body: rows,
      startY: 15,
      styles: {
        fontSize: 6, // ✅ Set font size here
      },
      headStyles: {
        fontSize: 6, // ✅ Also reduce header font
      },
    });
    doc.save(`customer_data.pdf`);
  };

  const handleEditCustomer = (row) => {
    setLicenseError("");
    setRcbookError("");
    setE_date_error("");
    setS_date_error("");
    setLicenseError("");
    setRcbookError("");
    setCompany_error("");
    setAddressError("");
    setInsurance_error("");
    setYearError("");
    setCustomerNameError("");
    setMobileError("");
    setVehicleNoError("");
    setEngineNoError("");
    setChasisNoError("");
    setBrandError("");
    setModelError("");
    setEmail_id_error("");
    setRc_start_error("");
    setRc_end_error("");
    setLicense_start_error("");
    setLicense_end_error("");

    setCustomerName(row[2]);
    setMobile(row[3]);
    setVehicleNo(row[4]);
    setEngineNo(row[5]);
    setChasisNo(row[6]);

    setBrand(row[7]);
    setModel(row[8]);
    setYear(row[9]);
    setAddress(row[10]);
    setMode("edit");
    setUsername(row[1]);
    setFlag_branch(row[11]);
    setCompany_name(row[13]);
    setInsurance_no(row[12]);
    setS_date(row[14] ? new Date(row[14]).toISOString().split("T")[0] : "");
    setE_date(row[15] ? new Date(row[15]).toISOString().split("T")[0] : "");
    setInsurance_type(row[16]);
    setRcbook(row[17]);
    setLicense(row[18]);
    if (row[19] == 0) {
      setIsInsurance(false);
    } else {
      setIsInsurance(true);
    }
    setInsurance_branch(row[20]);
    setB_mobile_no(row[21]);
    setB_address_no(row[22]);
    setEmail_id(row[23]);
    setBranch_code(row[24]);
    setCity(row[29]);
    setAgent(row[30]);
    setGst_type(row[31] || "");
    console.log(row);

    // Populate GST type options from the selected company's gst_list
    const selectedCompany = insurance.find(comp => comp[1] === row[13]);
    if (selectedCompany && Array.isArray(selectedCompany[4])) {
      setGst_type_options(selectedCompany[4].map(gst => ({
        value: gst.gstName,
        label: gst.gstName
      })));
    } else {
      setGst_type_options([]);
    }

    setRc_start(row[25] ? new Date(row[25]).toISOString().split("T")[0] : "");  
    setRc_end(row[26] ? new Date(row[26]).toISOString().split("T")[0] : "");    
    setLicense_start(
      row[27] ? new Date(row[27]).toISOString().split("T")[0] : ""
    );
    setLicense_end(
      row[28] ? new Date(row[28]).toISOString().split("T")[0] : ""
    );

    setOpen(true);
  };

  const handleInputChange1 = (e) => {
    const { value } = e.target;

    const vehicleNoPattern = /^[A-Z]{2}\d{2}[A-Z]{1,2}\d{4}$/;
    const formattedValue = value.toUpperCase();

    setVehicleNo(formattedValue);

    // if (!vehicleNoPattern.test(formattedValue)) {
    //     setVehicleNoError('Format: TN76AB1234 or TN67E8519');
    // } else {
    //     setVehicleNoError('');
    // }
    setVehicleNoError("");
  };

  return (
    <>
      <div
        className={`md:ml-[250px] w-full md:w-[calc(100%-250px)] mt-16 h-[92vh] flex justify-center items-center box-border ${
          theme === "dark"
            ? "bg-gray-900 text-white"
            : "bg-gray-100 text-gray-800"
        }`}
      >
        <div
          className={`w-[95%] md:w-[98%] h-[95%] px-4 py-2 rounded-xl shadow-xl overflow-auto ${
            theme === "dark"
              ? "bg-gray-800 text-gray-200"
              : "bg-white text-gray-800"
          }`}
        >
          {loading && (
            <div className="fixed inset-0 flex items-center justify-center bg-gray-200 bg-opacity-50 z-50">
              <img src={engineGif} alt="Loading..." className="w-24 h-24" />
            </div>
          )}
          <div className="w-full flex justify-between text-gray-600">
            <Head_data
              data="Manage Customer"
              font=""
              size="3xl"
              color={theme === "dark" ? "text-gray-200" : "text-gray-800"}
            ></Head_data>
            <button
              onClick={() => {
                setMode("add");
                setOpen(true);
                setCustomerName("");
                setMobile("");
                setVehicleNo("");
                setEngineNo("");
                setChasisNo("");
                setBrand("");
                setModel("");
                setYear("");
                setAddress("");
                setCity("");
                setAgent("");
                setCity_error("");
                setAgent_error("");
                setCustomerNameError("");
                setMobileError("");
                setVehicleNoError("");
                setEngineNoError("");
                setChasisNoError("");
                setBrandError("");
                setModelError("");
                setYearError("");
                setAddressError("");
                setInsurance_no("");
                setInsurance_error("");
                setCompany_error("");
                setCompany_name("");
                setS_date("");
                setS_date_error("");
                setE_date("");
                setE_date_error("");
                setInsurance_type("");
                setInsurance_type_error("");
                setRcbook("");
                setRcbookError("");
                setLicense("");
                setLicenseError("");
                setBranche_list([]);
                setInsurance_branch("");
                setB_address_no("");
                setB_mobile_no("");
                setIsInsurance(false);
                setEmail_id("");
                setEmail_id_error("");
                setBranch_code("");
                setBranch_code_error("");
                setGst_type("");
                setGst_type_options([]);

                setRc_start("");
                setRc_start_error("");
                setRc_end("");
                setRc_end_error("");
                setLicense_end("");
                setLicense_start("");
                setLicense_end_error("");
                setLicense_start_error("");
              }}
              className="px-4 py-2 text-white bg-blue-600 rounded hover:bg-blue-700 md:mt-2"
            >
              Add Customer
            </button>
          </div>

          <div className="flex justify-between items-center mb-4">
            <input
              type="text"
              placeholder="Search by mobile no ,vehicle no ,customer name , city and pincode"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full md:w-1/2 px-4 my-2 py-2 border border-gray-300 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200"
            />
            <button
              onClick={handleExportPDF}
              className="px-4 py-2 text-white bg-green-600 hover:bg-green-700 rounded"
            >
              Export PDF
            </button>
          </div>
          <div className="py-6 md:px-2 overflow-x-auto max-h-[70vh] overflow-y-auto">
            <DataTable
              columns={columns}
              data={filtered}
              customStyles={customStyles}
              pagination
            />
          </div>
        </div>
      </div>
      <Modal show={open} onClose={() => setOpen(false)} size="4xl">
        <Modal.Header className="bg-white text-gray-900 border-b border-gray-200">
          {mode === "add" ? "Add New Customer" : "Edit Customer"}
        </Modal.Header>
        <Modal.Body className="flowbite-modal-b">
          <div className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div>
                <Label htmlFor="customerName">Customer Name</Label>
                <TextInput
                  id="customerName"
                  name="customerName"
                  type="text"
                  value={customerName}
                  onChange={handleInputChange}
                  required
                  color={customerNameError ? "failure" : "white"}
                  helperText={customerNameError}
                />
              </div>
              <div>
                <Label htmlFor="mobile">Contact/whatsapp no</Label>
                <TextInput
                  id="mobile"
                  name="mobile"
                  type="number"
                  min="0"
                  value={mobile}
                  onChange={handleInputChange}
                  required
                  color={mobileError ? "failure" : "white"}
                  helperText={mobileError}
                />
              </div>
              <div>
                <Label htmlFor="email_id">Email Id</Label>
                <TextInput
                  id="email_id"
                  name="email_id"
                  type="email"
                  value={email_id}
                  onChange={handleInputChange}
                  // color={email_id_error ? 'failure' : 'white'}
                  // helperText={email_id_error}
                />
              </div>
              <div>
                <Label htmlFor="vehicleNo">Vehicle No</Label>
                <TextInput
                  id="vehicleNo"
                  name="vehicleNo"
                  type="text"
                  value={vehicleNo}
                  onChange={handleInputChange1}
                  required
                  color={vehicleNoError ? "failure" : "white"}
                  helperText={vehicleNoError}
                />
              </div>
              <div>
                <Label htmlFor="engineNo">Engine No</Label>
                <TextInput
                  id="engineNo"
                  name="engineNo"
                  type="text"
                  value={engineNo}
                  onChange={handleInputChange}
                  required
                  color={engineNoError ? "failure" : "white"}
                  helperText={engineNoError}
                />
              </div>
              <div>
                <Label htmlFor="chasisNo">Chasis No</Label>
                <TextInput
                  id="chasisNo"
                  name="chasisNo"
                  type="text"
                  value={chasisNo}
                  onChange={handleInputChange}
                  required
                  color={chasisNoError ? "failure" : "white"}
                  helperText={chasisNoError}
                />
              </div>
              <div>
                <label
                  htmlFor="brand"
                  className="block text-sm font-medium text-gray-700"
                >
                  Brand *
                </label>
                <Select
                  id="brand"
                  name="brand"
                  value={brands.find((brand1) => brand1[0] === brand)}
                  onChange={(selectedOption) => {
                    const selectedValue = selectedOption;
                    console.log("Selected brand:", selectedValue[0]);
                    setBrand(selectedValue[0]);
                  }}
                  options={[
                    ...new Map(brands.map((item) => [item[0], item])).values(),
                  ]}
                  getOptionLabel={(e) => e}
                  getOptionValue={(e) => e}
                  placeholder="Select a brand"
                  isSearchable
                  required
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                  maxMenuHeight={130}
                />

                {brandError && (
                  <p className="text-sm text-red-600">{brandError}</p>
                )}
              </div>

              <div>
                <label
                  htmlFor="model"
                  className="block text-sm font-medium text-gray-700"
                >
                  Model *
                </label>
                <Select
                  id="model"
                  name="model"
                  value={filteredModels.find(
                    (option) => option.value === model
                  )}
                  onChange={(selectedOption) => setModel(selectedOption.value)}
                  options={filteredModels}
                  placeholder="Select Model"
                  isSearchable
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                  maxMenuHeight={130}
                />
                {modelError && (
                  <p className="text-sm text-red-600">{modelError}</p>
                )}
              </div>
              <div>
                <Label htmlFor="year">Year</Label>
                <TextInput
                  id="year"
                  name="year"
                  type="number"
                  min="0"
                  value={year}
                  onChange={handleInputChange}
                  required
                  color={yearError ? "failure" : "white"}
                  helperText={yearError}
                />
              </div>
              <div>
                <Label htmlFor="address">Address</Label>
                <TextInput
                  id="address"
                  name="address"
                  type="text"
                  value={address}
                  onChange={handleInputChange}
                  required
                  color={addressError ? "failure" : "white"}
                  helperText={addressError}
                />
              </div>
              <div>
                <Label htmlFor="city">City</Label>
                <TextInput
                  id="city"
                  name="city"
                  type="text"
                  value={city}
                  onChange={handleInputChange}
                  required
                  color={city_error ? "failure" : "white"}
                  helperText={city_error}
                />
              </div>

              <div>
                <Label htmlFor="agent">Pin Code</Label>
                <TextInput
                  id="agent"
                  name="agent"
                  type="number"
                  value={agent}
                  onChange={handleInputChange}
                  required
                  color={agent_error ? "failure" : "white"}
                  helperText={agent_error}
                />
              </div>

              <div>
                <Label htmlFor="address">Branch</Label>
                <select
                  id="branch"
                  name="branch"
                  value={flag_branch}
                  onChange={handleInputChange}
                  className={`block w-full px-3 py-2 border rounded-md shadow-sm focus:ring focus:ring-blue-500 ${
                    flag_berror ? "border-red-500" : "border-gray-300"
                  }`}
                  required
                  disabled={sessionStorage.getItem("position") !== "superadmin"}
                >
                  <option value="" disabled>
                    Select Branch
                  </option>
                  {branches.map((data, index) => (
                    <option key={index} value={data[1]}>
                      {data[2]}
                    </option>
                  ))}
                </select>
                {flag_berror && (
                  <p className="text-sm text-red-600">{flag_berror}</p>
                )}
              </div>
            </div>
            {isinsurance && (
              <div>
                <hr />
                <p className="text-lg text-gray-500">Insurance</p>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div>
                    <Label htmlFor="address">Insurance Company</Label>
                    <select
                      id="company"
                      name="company"
                      value={company_name}
                      onChange={(e) => {
                        handleInputChange(e);
                      }}
                      className={`block w-full px-3 py-2 border rounded-md shadow-sm focus:ring focus:ring-blue-500 ${
                        flag_berror ? "border-red-500" : "border-gray-300"
                      }`}
                      required
                    >
                      <option value="" disabled>
                        Company
                      </option>
                      {insurance.map((data, index) => (
                        <option key={index} value={data[1]}>
                          {data[2]}
                        </option>
                      ))}
                    </select>
                    {company_error && (
                      <p className="text-sm text-red-600">{company_error}</p>
                    )}
                  </div>

                  <div className="relative">
                    <Label htmlFor="address">Insurance Branch</Label>
                    <TextInput
                      id="insurance_branch"
                      name="insurance_branch"
                      type="text"
                      color="white"
                      value={insurance_branch}
                      onChange={(e) => {
                        const inputValue = e.target.value || "";
                        setInsurance_branch(inputValue);
                        setB_address_no("");
                        setB_mobile_no("");
                        setBranch_code("");
                        setValue("");
                        console.log(
                          branch_list
                            .map((data) => data.branch)
                            .filter(
                              (branch) =>
                                typeof branch === "string" &&
                                branch
                                  .toLowerCase()
                                  .includes(inputValue.toLowerCase())
                            )
                        );

                        setFilteredOptions([
                          ...new Set(
                            branch_list
                              .map((data) => data.branch)
                              .filter(
                                (branch) =>
                                  typeof branch === "string" &&
                                  branch
                                    .toLowerCase()
                                    .includes(inputValue.toLowerCase())
                              )
                          ),
                        ]);
                      }}
                    />

                    {filteredOptions.length > 0 && (
                      <ul className="absolute w-full border border-gray-300 bg-white shadow-md rounded mt-1 max-h-40 overflow-auto z-50">
                        {filteredOptions.map((option, index) => (
                          <li
                            key={index}
                            onClick={() => {
                              const selectedBranch = branch_list.find(
                                (branch_l) => branch_l.branch === option
                              );

                              if (selectedBranch) {
                                setInsurance_branch(
                                  selectedBranch.branch || ""
                                );
                                setB_mobile_no(selectedBranch.mobile || "");
                                setB_address_no(selectedBranch.address || "");
                                setBranch_code(
                                  selectedBranch.branch_code || ""
                                );
                              }

                              setFilteredOptions([]);
                              setValue("1");
                            }}
                            className="p-2 hover:bg-blue-100 cursor-pointer"
                          >
                            {option}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>

                  <div>
                    <Label htmlFor="">Branch Mobile no</Label>
                    <TextInput
                      id="Branch Mobile no"
                      name="Branch Mobile no"
                      type="number"
                      value={b_mobile_no}
                      onChange={(e) => {
                        setB_mobile_no(e.target.value);
                      }}
                      color="white"
                    />
                  </div>
                  <div>
                    <Label htmlFor="">Branch Email</Label>
                    <TextInput
                      id="Branch Address"
                      name="Branch Address"
                      type="email"
                      value={b_address_no}
                      onChange={(e) => {
                        setB_address_no(e.target.value);
                      }}
                      color="white"
                    />
                  </div>
                  <div>
                    <Label htmlFor="">Branch Code</Label>
                    <TextInput
                      id="Branch Codde"
                      name="Branch code"
                      type="text"
                      value={branch_code}
                      onChange={(e) => {
                        setBranch_code(e.target.value);
                      }}
                      color="white"
                    />
                  </div>

                  <div>
                    <Label htmlFor="address">Insurance Number</Label>
                    <TextInput
                      id="insurance"
                      name="insurance"
                      type="text"
                      value={insurance_no}
                      onChange={handleInputChange}
                      required
                      color={insurance_error ? "failure" : "white"}
                      helperText={insurance_error}
                    />
                  </div>
                  <div>
                    <Label htmlFor="address">Insurance Type</Label>
                    <select
                      id="insurance_type"
                      name="insurance_type"
                      value={insurance_type}
                      onChange={handleInputChange}
                      className={`block w-full px-3 py-2 border rounded-md shadow-sm focus:ring focus:ring-blue-500 ${
                        insurance_type_error
                          ? "border-red-500"
                          : "border-gray-300"
                      }`}
                      required
                    >
                      <option value="" disabled>
                        Insurance Type
                      </option>

                      {types.map((type, index) => (
                        <option key={index} value={type[0]}>
                          {type[0]}
                        </option>
                      ))}
                    </select>

                    {insurance_type_error && (
                      <p className="text-sm text-red-600">
                        {insurance_type_error}
                      </p>
                    )}
                  </div>

                  <div>
                    <Label htmlFor="gst_type">GST Type</Label>
                    <select
                      id="gst_type"
                      value={gst_type}
                      onChange={(e) => setGst_type(e.target.value)}
                      className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-blue-500"
                    >
                      <option value="" disabled>
                        Select GST Type
                      </option>
                      {gst_type_options.map((option, index) => (
                        <option key={index} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <Label htmlFor="address">Insurance Start Date</Label>
                    <TextInput
                      id="insurance"
                      name="s_date"
                      type="date"
                      value={s_date}
                      onChange={handleInputChange}
                      required
                      color={s_date_error ? "failure" : "white"}
                      helperText={s_date_error}
                    />
                  </div>
                  <div>
                    <Label htmlFor="address">Insurance End Date</Label>
                    <TextInput
                      id="insurance"
                      name="e_date"
                      type="date"
                      value={e_date}
                      onChange={handleInputChange}
                      required
                      color={e_date_error ? "failure" : "white"}
                      helperText={e_date_error}
                    />
                  </div>
                  <div>
                    <Label htmlFor="rcbook">RC Book Number</Label>
                    <TextInput
                      id="rcbook"
                      type="text"
                      value={rcbook}
                      onChange={handleRcbookChange}
                      required
                      color={rcbookError ? "failure" : "white"}
                      helperText={rcbookError}
                    />
                  </div>
                  <div>
                    <Label htmlFor="rc">Rc Start Date</Label>
                    <TextInput
                      id="rc"
                      name="rc_start"
                      type="date"
                      value={rc_start}
                      onChange={handleInputChange}
                      required
                      color={rc_start_error ? "failure" : "white"}
                      helperText={rc_start_error}
                    />
                  </div>
                  <div>
                    <Label htmlFor="rc">Rc End Date</Label>
                    <TextInput
                      id="rc"
                      name="rc_end"
                      type="date"
                      value={rc_end}
                      onChange={handleInputChange}
                      required
                      color={rc_end_error ? "failure" : "white"}
                      helperText={rc_end_error}
                    />
                  </div>

                  <div>
                    <Label htmlFor="license">Driver License Number</Label>
                    <TextInput
                      id="license"
                      type="text"
                      value={license}
                      onChange={handleLicenseChange}
                      required
                      color={licenseError ? "failure" : "white"}
                      helperText={licenseError}
                    />
                  </div>
                  <div>
                    <Label htmlFor="license">License Start Date</Label>
                    <TextInput
                      id="license"
                      name="license_start"
                      type="date"
                      value={license_start}
                      onChange={handleInputChange}
                      required
                      color={license_start_error ? "failure" : "white"}
                      helperText={license_start_error}
                    />
                  </div>
                  <div>
                    <Label htmlFor="License">License End Date</Label>
                    <TextInput
                      id="license"
                      name="license_end"
                      type="date"
                      value={license_end}
                      onChange={handleInputChange}
                      required
                      color={license_end_error ? "failure" : "white"}
                      helperText={license_end_error}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer className="flowbite-modal-b">
          <div className=" w-full flex justify-between ">
            <div className="flex items-center">
              <input
                type="checkbox"
                checked={isinsurance}
                onChange={() => {
                  setIsInsurance(!isinsurance);
                  console.log(isinsurance);
                }}
              />
              <p className="ms-2"> Insurance </p>
            </div>

            <Button_submit
              onClick={() => {
                mode === "add" ? handleSubmit() : handleEdit();
              }}
              data={`${mode === "add" ? "Submit" : "Update"}`}
              type="submit"
              aditional="ms-auto"
            />
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Customer;
